import React from 'react';
import { ReactSVG } from "react-svg";
import i18n from '../../i18n/i18n.js';
import { Link  } from "react-router-dom";
import Search from "../../components/Search/Search.js";
import { AppContext, ModalsContext, withAppContext } from '../../contexts/AppContext';
import HorisontalCategoryPicker from '../HorisontalCategoryPicker/HorisontalCategoryPicker.js';
import './AppHeader.css';
import TypedLink from '../TypedLink/TypedLink.js';
import Minicart from '../Minicart/Minicart.js';
import CustomerBarcode from '../../components/CustomerBarcode/CustomerBarcode.js';

class AppHeader extends React.Component {
  static contextType = ModalsContext;

  logo = false;
  show_sign_in = false;
  className = '';

  constructor(props) {
    
    super(props);

    this.className = props.className ? props.className : '';
    
    this.appContext = this.props.appContext;

    this.state = {
      signed: this.appContext.appRef.current.get_is_signed()
    };

  }

  closeMenus() {
    const {ProfileMenuRef,ProductsMenuRef} = this.context;
    ProfileMenuRef.current.hide(); 
    ProductsMenuRef.current.hide();
  }

  handle_massages_click = () => {
      this.context.MyMessagesRef.current.show();
  }

  render() {
    const SearchRef = new React.createRef();
    const Categories = this.appContext?.appRef?.current?.state?.categories;

    return (
      <header className={this.className}>

        <div className='header-top'>
          
          <div className='notification-cont' onClick={this.handle_massages_click}>
            <ReactSVG src="/assets/images/notification.svg" />
            {this.appContext?.appRef?.current?.state?.unread_messages > 0 && <span className='notification-count'>{this.appContext?.appRef?.current?.state?.unread_messages}</span>}        
          </div>

          <Search ref={SearchRef} /> 
          {this.appContext.appRef.current.state.is_signed ? 
            <>
              <CustomerBarcode  />
              <TypedLink link={{type:"offline-coupons"}} href="" className='offline-coupons'><ReactSVG src="/assets/images/coupon_header.svg" /></TypedLink>
            </> 
          : ''}
          <Minicart ></Minicart>

        </div>

        {Categories?.pc>0 && Categories?.categories ?
        <div className='header-categories'>
          <HorisontalCategoryPicker key="app_header" flag="app_header" addHome={true} categories={Categories.categories} />
        </div>
        :''}

      </header>
    );
  }
};

export default withAppContext(AppHeader);

